import axiosInstance from './axiosInstance';

const authService = {
  login: (credentials) =>
    axiosInstance.post('/admin/auth/login', credentials),

  logout: () =>
    axiosInstance.post('/admin/auth/logout'),

  forgotPassword: (username) =>
    axiosInstance.post('/admin/auth/forgot-password', { username }),

  resetPassword: (token, new_password) =>
    axiosInstance.post('/admin/auth/reset-password', { token, new_password }),

  verifyEmail: (token) =>
    axiosInstance.post('/admin/auth/verify-email', { token }),
};

export default authService;
